<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="130px"
    >
      <el-form-item label="选择小程序">
        <el-tag
          v-if="app_id!=''"
          style="margin-right:10px"
        >{{ app_name }}</el-tag>
        <el-button
          size="mini"
          type="success"
          @click="wechawrt"
        >选择小程序</el-button>
      </el-form-item>
      <el-form-item label="小程序路径">
        <el-input
          v-model="path"
          placeholder="请输入小程序路径"
        />
      </el-form-item>
      <el-form-item label="小程序查询参数">
        <el-input
          v-model="query"
          placeholder="请输入小程序查询参数"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="remark"
          placeholder="请输入备注"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确认</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="小程序"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :append-to-body="true"
      :show="true"
      width="1000px"
    >
      <wechatlist
        ref="wechatlistview"
        @callback="callback"
      />
    </el-dialog>
  </div>
</template>

<script>
import { programmanageurlLinkadd } from '@/api/hugeAdvertGroup.js'
import wechatlist from './wechatlist.vue'
export default {
  components: { wechatlist },
  data() {
    return {
      labelPosition: 'right',
      app_name: '',
      app_id: '',
      path: '',
      query: '',
      remark: '',
      dialogVisible: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    async sumbit() {
      const data = await programmanageurlLinkadd({
        app_id: this.app_id,
        path: this.path,
        query: this.query,
        remark: this.remark
      })
      this.$emit('updata')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
    },
    wechawrt() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.wechatlistview.send()
      })
    },
    callback(item) {
      this.dialogVisible = false
      this.app_name = item.account_name
      this.app_id = item.app_id
      console.log(item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
